/**
 * External Imports
 */
import { FC, Dispatch, SetStateAction } from 'react';

/**
 * Nexus Imports
 */
import { NeuNavVertical } from '@neutron/react';

/**
 * Style Imports
 */
import { SideNavLabel } from '../SideNav.styles';

interface INavItemType {
  tabLabel: string;
  tabId: string;
}

interface ISideNavProps {
  navItems: INavItemType[];
  className?: string;
  selectedTab: string;
  showNewMasterTemplate?: boolean;
  setSelectedTab: Dispatch<SetStateAction<string>>;
}

const SideNav: FC<ISideNavProps> = ({
  navItems,
  className = 'ps-2',
  selectedTab,
  showNewMasterTemplate,
  setSelectedTab
}) => {
  const changeTab = (tab: string) => {
    setSelectedTab(tab);
  };

  return (
    <NeuNavVertical
      id="Admin-Side-Nav"
      className="h-auto"
      kind="outlined"
      label="MENU"
      menu="blue"
      mode="drawer"
      style={{
        boxShadow: 'rgba(0, 0, 0, 0.15) 0 2px 4px',
        '--nav-width-drawer': 'clamp(200px, 25vw, 200px)'
      }}
    >
      <NeuNavVertical
        unit="header"
        style={{
          padding:
            '0 calc(var(--nav-padding-x) / 1.5) calc(var(--nav-padding-y) / 0.75)'
        }}
      />
      <NeuNavVertical unit="content">
        {navItems &&
          navItems.map((item: INavItemType) => {
            return (
              <NeuNavVertical
                key={item.tabId}
                className={className}
                active={!showNewMasterTemplate && selectedTab === item.tabId}
                disabled={showNewMasterTemplate}
                unit="item"
                onClick={() => changeTab(item.tabId)}
              >
                <SideNavLabel>{item.tabLabel}</SideNavLabel>
              </NeuNavVertical>
            );
          })}
      </NeuNavVertical>
    </NeuNavVertical>
  );
};

export default SideNav;
